 
 /* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import helper from '../../helpers';
import utils from '../../../../lib/utils';
import Loading from '../../../common/Loading';
import closeIcon from '../../../../assets/images/close_icon_dark.svg';
import './index.scss';

Modal.setAppElement('#root');

class CreateContact extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state={
      firstname:'',
      lastname:'',
      phone:'',
      email:'',
      error:{}
    }
    this.inputReference = React.createRef();
  }

 componentWillReceiveProps(nextProps){
   if(nextProps.createdContact && !utils.isEmptyObject(nextProps.createdContact)){
     const { createdContact } = nextProps;
     this.setState({
      firstname:createdContact.first_name,
      lastname:createdContact.last_name,
      phone:createdContact.phone,
      email:createdContact.email,
     })
   }
  console.log('searchText',nextProps);
 }
 componentDidMount(){
  if(this.props.createdContact && !utils.isEmptyObject(this.props.createdContact)){
    const { createdContact } = this.props;
    this.setState({
     firstname:createdContact.first_name,
     lastname:createdContact.last_name,
     phone:createdContact.phone,
     email:createdContact.email,
    })
  }else if(this.props.searchText && utils.isEmptyObject(this.props.createdContact)){
    let phone = '';
    let firstname = '';
    let lastname = '';
    let email = '';
    let errorObject = {};
    let temp = this.props.searchText;
    if(helper.validatePhoneNumber(temp)){
      phone=temp;
    }else if(utils.isValidEmail(temp)){
      email = temp;
    }else{
      const names = temp.split(' ');
      if(names.length>0){
        names.forEach(element => {
          if(/^\d+$/.test(element)){
            phone = element;
            if(!helper.validatePhoneNumber(phone)){
              errorObject['phone'] = 'Please enter a valid phone number';
            }
          }else{
            if(firstname===''){
            firstname = element;
            }else{
              lastname += element+' ';
            }
          }
        });
       }
    }
    this.setState({
      firstname,
      lastname,
      phone,
      email,
      ...(!utils.isEmptyObject(errorObject),{error:errorObject})
     })

  }
 }

  closeModal() {
    this.props.setblockOverlayVisibility(false);
    this.setState({
      firstname:'',
      lastname:'',
      phone:'',
      email:'',
      error:{},
    })
  }

  handleChange = (event)=>{
    const errorObject = {...this.state.error};

    if(event.target.name==='firstname'||event.target.name==='lastname'){
      if(event.target.value.trim().length<1){
        errorObject[event.target.name] = 'Please enter a valid name';
      }else{
        delete errorObject[event.target.name];
      }
      if(event.target.value===''||event.target.value===null){
        delete errorObject[event.target.name];
      }
    }
    if(event.target.name==='phone') {
      if(!helper.validatePhoneNumber(event.target.value)){
        errorObject[event.target.name] = 'Please enter a valid phone number';
      }else{
        delete errorObject[event.target.name];
      }
    }
    if(event.target.name==='email') {
      if(!utils.isValidEmail(event.target.value)){
        errorObject[event.target.name] = 'Please enter a valid email';
      }else{
        delete errorObject[event.target.name];
      }
      if(event.target.value===''||event.target.value===null){
        delete errorObject[event.target.name];
      }
    }
    this.setState({
      ...(event.target.name!=='phone' && {[event.target.name]:event.target.value}),
      ...(event.target.name==='phone' && {[event.target.name]:event.target.value.replace(/([a-zA-Z])/g, "")}),
      error:errorObject
    })
  }
  sendButtonStatus =()=>{
    const { error, phone } = this.state;
    if( utils.isEmptyObject(error) && phone.length>0 && !this.props.isAdvancedSearch){
      return false;
    }else{
      return true;
    }
  }

  render() {
    const {modelopen,errorData, isAdvancedSearch} = this.props;
    const { error, firstname, lastname, email, phone } = this.state;
    console.log('FirstName',firstname, lastname, email, phone);
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="overlay-top mobile-full-model"
          contentLabel="Example Modal"
        >
          <div>
          <div>
            <div className="modal-header">
              <div className="title">Start New Conversation</div>
              <button className="modal-close" onClick={this.closeModal}><img src={closeIcon}/></button>
              <div className="input">
                <label className="label">First Name</label>
                <input type="text" name="firstname" className={error.firstname?'error-input':''} value={this.state.firstname} onChange={(event)=>this.handleChange(event)} maxlength="100"/>
                {error.firstname && <div className="error-message">{error.firstname}</div>}
              </div>
              <div className="input">
                <label className="label">Last Name</label>
                <input type="text" name="lastname" className={error.lastname?'error-input':''} value={this.state.lastname} onChange={(event)=>this.handleChange(event)} maxlength="100"/>
                {error.lastname && <div className="error-message">{error.lastname}</div>}
              </div>
              <div className="input">
                <label className="label">phone number <span>(Required)</span></label>
                <div className="block-number">
                <input type="text" ref={this.inputReference} name="phone" className={error.phone?'error-input':''} value={this.state.phone} onChange={(event)=>this.handleChange(event)} maxlength="100" autoFocus={this.state.phone?.length<10 && window.innerWidth>767}/>
                </div>
                {error.phone && <div className="error-message">{error.phone}</div>}
              </div>
              <div className="input">
                <label className="label">Email</label>
                <input type="text" name="email" className={error.email?'error-input':''} value={this.state.email} onChange={(event)=>this.handleChange(event)} maxlength="100"/>
                {error.email && <div className="error-message">{error.email}</div>}
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={()=>this.props.saveContact({"first_name":firstname , "last_name":lastname,"email":email, "phone":phone,"id":"NEW"})} disabled={this.sendButtonStatus()}>
                    {(isAdvancedSearch) ?'Looking for contacts..':'START'}
                    </button>
              </div>
            </div>
          </div>
  
          {/* {(errorData.errorReportSucess && !errorData.postErrorReport ) &&
              <div className="modal-header">
              <div className="title">Blocking success</div>
              <button className="modal-close" onClick={this.closeModal}>X</button>
              <div className="sub-title">This number will not be allowed to text or call into TrueLark.
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.closeModal}>
                    OK
                    </button>
              </div>
            </div>
            }  */}
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default CreateContact;

